<template>
  <div class="draw_production" :class="` ${initWinner ? 'init_winner' : ''}`">
    <!-- <video ref="video" class="video" loop></video> -->

    <div
      :class="`draw_background ${participants.length ? 'blur' : ''}`"
      :style="{
        backgroundImage: item.background_image
          ? 'url(' + item.background_image + ')'
          : '',
      }"
    ></div>

    <div class="draw_color"></div>

    <!-- <div class="draw_background_color">
      <div class="draw_brands">
        <div><img class="color-svg-white" src="@/assets/img/logo-2.svg" /></div>
      </div>
    </div> -->

    <div v-if="!participants.length" class="draw_production-content">
      <div class="draw_production-content-body">
        <!-- <h2 :style="{ color: item.button_text_color }">{{ item.title }}</h2> -->

        <button
          v-if="item.participants.length"
          :disabled="participants.length > 0 || initWinner"
          @click="getWinner"
          :style="{
            color: '#fff',
            background: item.button_background_color,
          }"
          class="button button-get_winner"
        >
          {{ item.button_text }}
        </button>

        <div
          ref="participant"
          v-on:scroll="scrollFunction"
          class="draw_production-content-body-participants"
        >
          <ul
            ref="participant_list"
            :class="`${initWinner ? 'init_winner' : ''}`"
          >
            <li
              :style="{ color: item.button_text_color }"
              v-for="(participant, key) in item.participants"
              :key="key"
            >
              {{ participant.title }}
            </li>
            <!-- <li
             
              v-for="participant in additionalItems"
              :key="`key-${participant.id}`"
              button_background_color
            >
              {{ participant.title_additional }} {{ participant.title }}
            </li> -->
          </ul>
        </div>
      </div>
    </div>

    <div v-if="participants.length" class="draw_production-winner">
      <h2 class="winner-title" :style="{ color: item.button_text_color }">
        ПОБЕДИТЕЛЬ
      </h2>
      <ul>
        <li v-for="(participant, key) in participants" :key="key">
          <div class="winner">
            <!-- {{ participant.title_additional }} -->
            {{ participant.title }}
          </div>
        </li>
      </ul>

      <!-- <textarea v-model="label" rows="4"></textarea>
          <br /> -->
      <!-- 
          <button @click="setWinner">Сохранить результат</button>
          <br />
          <br /> -->
      <!-- <button class="button" @click="participants = []">Отменить результат</button> -->

      <button
        class="button"
        :style="{
          color: '#fff',
          background: item.button_background_color,
        }"
        @click="restart()"
      >
        Выбрать победителя
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    cardLink: "admin/draws/production/card",
    cardSetLink: "admin/draws/production/set",

    winnderByDepartment: [
      {
        additionalTitle: "муж",
        maxWinners: 20,
      },
      {
        additionalTitle: "жен",
        maxWinners: 20,
      },
      
    ],

    item: {
      participants: [],
    },
    participants: [],
    additionalItems: [],
    label: "",
    initWinner: false,
    speedAnimation: 10,
    timer: null,
    winners: {},
    // Массив для хранения всех победителей (чтобы не повторялись)
    allWinners: [],
    // Последний выбранный отдел (для чередования)
    lastSelectedDepartment: null,
    // Отслеживание количества победителей по отделам
    winnersByDepartmentCount: {},
    // Предварительный порядок отделов для выбора (чтобы не повторялись)
    departmentSelectionOrder: [],
    // Индекс текущего отдела в предварительном порядке
    currentDepartmentIndex: 0,

    loading: true,
  }),
  props: ["id"],
  computed: {
    lengthPart: {
      get() {
        return this.item.participants.length;
      },
    },
  },
  async mounted() {
    this.$loading(true);

    // try {
    //   let video = await require("@/assets/media.mp4");
    //   this.$refs.video.src = await video;
    //   //check if loaded

    //   //check if loaded video then play

    //   // this.$refs.video.onloadeddata = () => {

    //   // };

    //   setInterval(() => {
    //     //if already loaded and play dont play

    //     if(this.$refs.video.paused){
    //       this.$refs.video.play();
    //       this.$refs.video.click();

    //     }

    //   }, 2000);
    // } catch (error) {
    //   console.log(error);
    // }

    this.getItem();
    //load video
  },
  methods: {
    restart() {
      console.log(
        "\n🔄 RESTART: Очищаем текущих победителей, выбираем новых..."
      );
      console.log("Всего победителей до restart:", this.allWinners.length);
      this.participants = [];

      setTimeout(() => {
        this.getWinner();
      }, 50);
    },

    /**
     * Группирует участников по отделам (title_additional)
     * @param {Array} participantsList - список участников
     * @returns {Object} объект с ключами - названиями отделов, значениями - массивы участников
     */
    groupByDepartment(participantsList) {
      const grouped = {};
      participantsList.forEach((participant) => {
        const department = participant.title_additional || "Без отдела";
        if (!grouped[department]) {
          grouped[department] = [];
        }
        grouped[department].push(participant);
      });
      return grouped;
    },

    /**
     * Генерирует полный план выбора отделов на основе maxWinners
     * Отделы распределяются так, чтобы не повторялись друг за другом
     * Начинается с наибольшего maxWinners и чередуется по убыванию
     * @param {Array} availableDepartments - список доступных отделов
     * @returns {Array} массив отделов в порядке выбора (длина = сумма всех maxWinners)
     */
    generateDepartmentOrder(availableDepartments) {
      // Создаем массив отделов с информацией о maxWinners и оставшихся выборах
      const departments = availableDepartments.map((deptName) => {
        const config = this.winnderByDepartment.find(
          (d) => d.additionalTitle === deptName
        );
        return {
          name: deptName,
          maxWinners: config ? config.maxWinners : 0,
          remaining: config ? config.maxWinners : 0,
        };
      });

      // Сортируем по maxWinners (от большего к меньшему)
      departments.sort((a, b) => b.maxWinners - a.maxWinners);

      // Вычисляем общее количество выборов
      const totalSelections = departments.reduce(
        (sum, dept) => sum + dept.remaining,
        0
      );

      // Создаем полный план выбора
      const selectionPlan = [];
      let lastSelectedDept = null;

      for (let i = 0; i < totalSelections; i++) {
        // Фильтруем отделы, у которых еще есть оставшиеся выборы
        const availableDepts = departments.filter((d) => d.remaining > 0);

        if (availableDepts.length === 0) break;

        let selectedDept = null;

        if (lastSelectedDept === null) {
          // Первый выбор - берем отдел с наибольшим maxWinners
          selectedDept = availableDepts[0];
        } else {
          // Ищем отдел, который отличается от последнего выбранного
          // Приоритет отдаем отделам с большим количеством оставшихся выборов
          const otherDepts = availableDepts.filter(
            (d) => d.name !== lastSelectedDept.name
          );

          if (otherDepts.length > 0) {
            // Сортируем по оставшимся выборам (от большего к меньшему)
            otherDepts.sort((a, b) => b.remaining - a.remaining);
            selectedDept = otherDepts[0];
          } else {
            // Если остался только один отдел (не должно быть, но на всякий случай)
            selectedDept = availableDepts[0];
          }
        }

        // Добавляем отдел в план
        selectionPlan.push(selectedDept.name);
        selectedDept.remaining--;
        lastSelectedDept = selectedDept;
      }

      console.log(
        "\n📋 Полный план выбора отделов (всего выборов:",
        totalSelections,
        "):"
      );

      // Подсчитываем количество выборов для каждого отдела в плане
      const deptCounts = {};
      selectionPlan.forEach((dept) => {
        deptCounts[dept] = (deptCounts[dept] || 0) + 1;
      });

      // Выводим план с информацией о количестве оставшихся выборов после каждого шага
      const deptUsed = {};
      selectionPlan.forEach((dept, idx) => {
        deptUsed[dept] = (deptUsed[dept] || 0) + 1;
        const maxWinners = this.getMaxWinnersForDepartment(dept);
        const remaining = maxWinners - deptUsed[dept];
        console.log(
          `  ${idx + 1}. ${dept} | осталось после выбора: ${remaining}`
        );
      });

      console.log("\n📊 Распределение по отделам:");
      Object.keys(deptCounts).forEach((dept) => {
        const maxWinners = this.getMaxWinnersForDepartment(dept);
        console.log(
          `  - ${dept}: ${deptCounts[dept]} выборов из ${maxWinners}`
        );
      });

      return selectionPlan;
    },

    /**
     * Получает максимальное количество победителей для отдела
     * @param {String} departmentName - название отдела
     * @returns {Number} максимальное количество победителей или Infinity, если лимит не установлен
     */
    getMaxWinnersForDepartment(departmentName) {
      const departmentConfig = this.winnderByDepartment.find(
        (dept) => dept.additionalTitle === departmentName
      );
      return departmentConfig ? departmentConfig.maxWinners : Infinity;
    },

    /**
     * Проверяет, достигнут ли лимит победителей для отдела
     * @param {String} departmentName - название отдела
     * @returns {Boolean} true, если лимит достигнут
     */
    isDepartmentLimitReached(departmentName) {
      const maxWinners = this.getMaxWinnersForDepartment(departmentName);
      if (maxWinners === Infinity) return false;

      const currentCount = this.winnersByDepartmentCount[departmentName] || 0;
      return currentCount >= maxWinners;
    },

    /**
     * Получает следующий отдел из предварительного плана выбора
     * @param {Object} groupedParticipants - сгруппированные участники
     * @param {Set} usedInCurrentRound - множество отделов, уже использованных в текущем раунде
     * @returns {String|null} название отдела или null
     */
    getNextDepartmentFromOrder(
      groupedParticipants,
      usedInCurrentRound = new Set()
    ) {
      // Получаем список разрешенных отделов из winnderByDepartment
      const allowedDepartments = new Set(
        this.winnderByDepartment.map((dept) => dept.additionalTitle)
      );

      // Ищем следующий доступный отдел в предварительном плане
      // Пропускаем уже использованные в текущем раунде, но следуем плану
      for (let i = 0; i < this.departmentSelectionOrder.length; i++) {
        const deptIndex =
          (this.currentDepartmentIndex + i) %
          this.departmentSelectionOrder.length;
        const dept = this.departmentSelectionOrder[deptIndex];

        // Проверяем, что отдел:
        // 1. Есть в разрешенных
        // 2. Есть в groupedParticipants (есть участники)
        // 3. Не достиг лимита
        // 4. Не использован в текущем раунде (если это не последний доступный)
        if (
          allowedDepartments.has(dept) &&
          groupedParticipants[dept] &&
          !this.isDepartmentLimitReached(dept)
        ) {
          // Если отдел уже использован в текущем раунде, пропускаем его
          if (usedInCurrentRound.has(dept)) {
            continue;
          }

          this.currentDepartmentIndex =
            (deptIndex + 1) % this.departmentSelectionOrder.length;
          return dept;
        }
      }

      // Если все отделы из плана использованы в текущем раунде,
      // но есть доступные отделы, берем первый доступный
      const availableDepts = Object.keys(groupedParticipants).filter(
        (dept) =>
          allowedDepartments.has(dept) &&
          !this.isDepartmentLimitReached(dept) &&
          !usedInCurrentRound.has(dept)
      );

      if (availableDepts.length > 0) {
        return availableDepts[0];
      }

      return null;
    },

    /**
     * Получает список отделов, исключая последний выбранный и отделы с достигнутым лимитом
     * @param {Object} groupedParticipants - сгруппированные участники
     * @param {Set} usedInCurrentRound - множество отделов, уже использованных в текущем раунде
     * @returns {Array} массив названий отделов
     */
    getAvailableDepartments(
      groupedParticipants,
      usedInCurrentRound = new Set()
    ) {
      // Получаем список разрешенных отделов из winnderByDepartment
      const allowedDepartments = new Set(
        this.winnderByDepartment.map((dept) => dept.additionalTitle)
      );

      let departments = Object.keys(groupedParticipants).filter((dept) =>
        allowedDepartments.has(dept)
      );

      // Исключаем отделы с достигнутым лимитом победителей
      departments = departments.filter(
        (dept) => !this.isDepartmentLimitReached(dept)
      );

      // Исключаем отделы, уже использованные в текущем раунде
      if (usedInCurrentRound.size > 0) {
        departments = departments.filter(
          (dept) => !usedInCurrentRound.has(dept)
        );
      }

      // Если после исключения использованных отделов не осталось доступных,
      // но есть отделы с не достигнутым лимитом, используем их
      if (departments.length === 0) {
        departments = Object.keys(groupedParticipants).filter(
          (dept) =>
            allowedDepartments.has(dept) && !this.isDepartmentLimitReached(dept)
        );
      }

      // Исключаем последний выбранный отдел (из предыдущего раунда), если есть другие
      if (this.lastSelectedDepartment && departments.length > 1) {
        departments = departments.filter(
          (dept) => dept !== this.lastSelectedDepartment
        );
      }

      return departments;
    },

    /**
     * Выбирает случайного участника из отдела
     * @param {Array} departmentParticipants - участники отдела
     * @param {Set} usedIds - множество ID уже выбранных участников
     * @returns {Object|null} выбранный участник или null
     */
    selectRandomFromDepartment(departmentParticipants, usedIds) {
      // Фильтруем участников, исключая уже выбранных
      const available = departmentParticipants.filter(
        (p) => !usedIds.has(p.id)
      );
      if (available.length === 0) return null;

      const randomIndex = Math.floor(Math.random() * available.length);
      return available[randomIndex];
    },

    getWinner() {
      this.initWinner = true;
      setTimeout(() => {
        // Получаем список разрешенных отделов из winnderByDepartment
        const allowedDepartments = new Set(
          this.winnderByDepartment.map((dept) => dept.additionalTitle)
        );

        // Фильтруем участников: оставляем только тех, чьи отделы есть в winnderByDepartment
        // и исключаем уже выбранных победителей
        const availableParticipants = this.item.participants.filter(
          (p) =>
            allowedDepartments.has(p.title_additional) &&
            !this.allWinners.some((w) => w.id === p.id)
        );

        console.log("=== НАЧАЛО ВЫБОРА ПОБЕДИТЕЛЕЙ ===");
        console.log("Разрешенные отделы:", Array.from(allowedDepartments));
        console.log(
          "Доступных участников (только из разрешенных отделов):",
          availableParticipants.length
        );
        console.log("Уже выбранных победителей:", this.allWinners.length);
        console.log("Последний выбранный отдел:", this.lastSelectedDepartment);
        console.log("📋 Лимиты по отделам:");
        this.winnderByDepartment.forEach((dept) => {
          const currentCount =
            this.winnersByDepartmentCount[dept.additionalTitle] || 0;
          const isReached = currentCount >= dept.maxWinners;
          console.log(
            `  - ${dept.additionalTitle}: ${currentCount}/${dept.maxWinners} ${
              isReached ? "❌ ЛИМИТ ДОСТИГНУТ" : "✅"
            }`
          );
        });

        if (availableParticipants.length === 0) {
          console.log("❌ Нет доступных участников из разрешенных отделов!");
          alert("Нет участников");
          this.initWinner = false;
          return;
        }

        // Группируем по отделам (только из разрешенных отделов)
        const groupedByDepartment = this.groupByDepartment(
          availableParticipants
        );

        // Фильтруем группы, оставляя только разрешенные отделы
        Object.keys(groupedByDepartment).forEach((dept) => {
          if (!allowedDepartments.has(dept)) {
            delete groupedByDepartment[dept];
          }
        });

        console.log("📊 Группировка по отделам (только разрешенные):");
        Object.keys(groupedByDepartment).forEach((dept) => {
          if (allowedDepartments.has(dept)) {
            console.log(
              `  - ${dept}: ${groupedByDepartment[dept].length} участников`
            );
          }
        });

        // Проверяем, есть ли отделы, которые еще не достигли лимита
        const allowedDepartmentsSet = new Set(
          this.winnderByDepartment.map((dept) => dept.additionalTitle)
        );
        const availableDepartments = this.getAvailableDepartments(
          groupedByDepartment,
          new Set()
        );
        if (
          availableDepartments.length === 0 &&
          Object.keys(groupedByDepartment).length > 0
        ) {
          // Все отделы достигли лимита, но есть участники
          const allDepartmentsReached = Object.keys(groupedByDepartment)
            .filter((dept) => allowedDepartmentsSet.has(dept))
            .every((dept) => this.isDepartmentLimitReached(dept));
          if (allDepartmentsReached) {
            console.log("❌ Все отделы достигли лимита победителей!");
            //alert("Все отделы достигли лимита победителей!");
            this.initWinner = false;
            return;
          }
        }

        // Генерируем полный план выбора отделов на основе всех maxWinners
        // План создается один раз и используется для всех выборов
        if (this.departmentSelectionOrder.length === 0) {
          // Создаем план на основе всех отделов из winnderByDepartment
          const allDepartments = this.winnderByDepartment.map(
            (dept) => dept.additionalTitle
          );
          this.departmentSelectionOrder =
            this.generateDepartmentOrder(allDepartments);
          this.currentDepartmentIndex = 0;
          console.log(
            "\n📋 Полный план выбора отделов создан (всего выборов:",
            this.departmentSelectionOrder.length,
            ")"
          );
        } else {
          console.log("\n📋 Используем существующий план выбора отделов");
          console.log(
            "  Текущая позиция в плане:",
            this.currentDepartmentIndex,
            "из",
            this.departmentSelectionOrder.length
          );
        }

        // Множество ID уже выбранных победителей (для быстрой проверки)
        const usedWinnerIds = new Set(this.allWinners.map((w) => w.id));

        // Множество отделов, использованных в текущем раунде (чтобы не повторялись)
        const usedInCurrentRound = new Set();

        // Количество победителей для выбора
        let winnerCount = this.item.winner_at_once;
        if (winnerCount > availableParticipants.length) {
          winnerCount = availableParticipants.length;
        }

        const newWinners = [];
        let currentDepartment = null;

        console.log(`\n🎯 Выбираем ${winnerCount} победителя(ей):`);

        for (let i = 0; i < winnerCount; i++) {
          console.log(`\n[Победитель ${i + 1}/${winnerCount}]`);

          // Получаем следующий отдел из предварительного порядка
          currentDepartment = this.getNextDepartmentFromOrder(
            groupedByDepartment,
            usedInCurrentRound
          );

          if (!currentDepartment) {
            // Если нет доступных отделов (все достигли лимита), прерываем выбор
            console.log(
              "  ❌ Все отделы достигли лимита победителей, прерываем выбор"
            );
            break;
          }

          console.log(
            `  ✅ Выбран отдел из предварительного порядка: ${currentDepartment}`
          );

          // Выбираем случайного участника из выбранного отдела
          let selectedParticipant = this.selectRandomFromDepartment(
            groupedByDepartment[currentDepartment],
            usedWinnerIds
          );
          let selectedDepartment = currentDepartment;

          if (!selectedParticipant) {
            console.log(
              `  ⚠️ В отделе "${currentDepartment}" нет доступных участников, ищем в других отделах по предварительному порядку...`
            );
            // Если в этом отделе нет доступных участников, пробуем другой отдел
            // Используем предварительный порядок, но не изменяем currentDepartmentIndex
            let found = false;
            const tempUsedInRound = new Set([
              ...usedInCurrentRound,
              currentDepartment,
            ]);
            const allowedDepartments = new Set(
              this.winnderByDepartment.map((dept) => dept.additionalTitle)
            );

            // Ищем следующий отдел из предварительного порядка (начиная с текущего индекса)
            for (let j = 0; j < this.departmentSelectionOrder.length; j++) {
              const deptIndex =
                (this.currentDepartmentIndex + j) %
                this.departmentSelectionOrder.length;
              const nextDept = this.departmentSelectionOrder[deptIndex];

              // Проверяем, что отдел доступен
              if (
                allowedDepartments.has(nextDept) &&
                groupedByDepartment[nextDept] &&
                !this.isDepartmentLimitReached(nextDept) &&
                !tempUsedInRound.has(nextDept) &&
                nextDept !== currentDepartment
              ) {
                const participant = this.selectRandomFromDepartment(
                  groupedByDepartment[nextDept],
                  usedWinnerIds
                );

                if (participant) {
                  selectedParticipant = participant;
                  selectedDepartment = nextDept;
                  // Обновляем индекс только когда нашли участника
                  this.currentDepartmentIndex =
                    (deptIndex + 1) % this.departmentSelectionOrder.length;
                  found = true;
                  console.log(`  ✅ Найден участник в отделе: ${nextDept}`);
                  break;
                }
              }
            }

            if (!found) {
              console.log(
                "  ❌ Не найдено доступных участников ни в одном отделе с не достигнутым лимитом"
              );
              break;
            }
          }

          // Добавляем выбранного участника в победители
          newWinners.push(selectedParticipant);
          usedWinnerIds.add(selectedParticipant.id);
          this.lastSelectedDepartment = selectedDepartment;

          // Добавляем отдел в список использованных в текущем раунде
          usedInCurrentRound.add(selectedDepartment);

          // Обновляем счетчик победителей для отдела
          if (!this.winnersByDepartmentCount[selectedDepartment]) {
            this.winnersByDepartmentCount[selectedDepartment] = 0;
          }
          this.winnersByDepartmentCount[selectedDepartment]++;

          console.log(
            `  🏆 Победитель: ${selectedParticipant.title_additional} - ${selectedParticipant.title} (ID: ${selectedParticipant.id})`
          );
          console.log(
            `  📊 Победителей в отделе "${selectedDepartment}": ${
              this.winnersByDepartmentCount[selectedDepartment]
            }/${this.getMaxWinnersForDepartment(selectedDepartment)}`
          );

          // Удаляем выбранного участника из группы, чтобы не выбирать его снова
          if (groupedByDepartment[selectedDepartment]) {
            const deptIndex = groupedByDepartment[selectedDepartment].findIndex(
              (p) => p.id === selectedParticipant.id
            );
            if (deptIndex !== -1) {
              groupedByDepartment[selectedDepartment].splice(deptIndex, 1);
            }

            // Если отдел пуст или достиг лимита, удаляем его из доступных
            if (groupedByDepartment[selectedDepartment].length === 0) {
              delete groupedByDepartment[selectedDepartment];
            } else if (this.isDepartmentLimitReached(selectedDepartment)) {
              // Отдел достиг лимита, удаляем его из доступных для следующих итераций
              console.log(
                `  ⚠️ Отдел "${selectedDepartment}" достиг лимита, исключаем из дальнейшего выбора`
              );
              delete groupedByDepartment[selectedDepartment];
            }
          }
        }

        // Добавляем новых победителей в общий список
        this.allWinners.push(...newWinners);
        this.participants = [...newWinners];

        // Удаляем выбранных участников из item.participants
        newWinners.forEach((winner) => {
          const index = this.item.participants.findIndex(
            (p) => p.id === winner.id
          );
          if (index !== -1) {
            this.item.participants.splice(index, 1);
          }
        });

        console.log("\n=== РЕЗУЛЬТАТЫ ВЫБОРА ===");
        console.log("✅ Новые победители в этом раунде:", newWinners.length);
        newWinners.forEach((winner, idx) => {
          console.log(
            `  ${idx + 1}. ${winner.title_additional} - ${winner.title} (ID: ${
              winner.id
            })`
          );
        });

        console.log("\n📋 ВСЕ ПОБЕДИТЕЛИ (всего):", this.allWinners.length);
        this.allWinners.forEach((winner, idx) => {
          console.log(
            `  ${idx + 1}. ${winner.title_additional} - ${winner.title} (ID: ${
              winner.id
            })`
          );
        });

        console.log(
          `\n📊 Осталось участников: ${this.item.participants.length}`
        );
        console.log(
          `🔄 Последний выбранный отдел: ${this.lastSelectedDepartment}`
        );
        console.log("\n📋 Финальное состояние лимитов по отделам:");
        this.winnderByDepartment.forEach((dept) => {
          const currentCount =
            this.winnersByDepartmentCount[dept.additionalTitle] || 0;
          const isReached = currentCount >= dept.maxWinners;
          console.log(
            `  - ${dept.additionalTitle}: ${currentCount}/${dept.maxWinners} ${
              isReached ? "❌ ЛИМИТ ДОСТИГНУТ" : "✅"
            }`
          );
        });
        console.log("=== КОНЕЦ ВЫБОРА ПОБЕДИТЕЛЕЙ ===\n");

        this.initWinner = false;
      }, 2000);
    },

    runAnimate() {
      clearTimeout(this.timer);

      // console.log(this.$refs.participant.$el);

      ///select ul child element
      if (this.$refs.participant) {
        let li = this.$refs.participant.querySelector("ul");
        //select li position who top 0 scroll

        //select li position who top 0 scroll
        //let li = this.$refs.participant.querySelector("li").style.opacity = '0.1';
        // console.log(ul);
      }

      this.timer = setInterval(() => {
        try {
          if (this.$refs.participant) {
            this.$refs.participant.scrollTop =
              this.$refs.participant.scrollTop + 3;
          }
        } catch (error) {}
      }, this.speedAnimation);
    },
    scrollFunction(val) {
      try {
        let allHeight = this.$refs.participant_list.offsetHeight;

        // console.log("CURRENT", val.target.scrollTop);
        // console.log("allHeight", allHeight);

        if (val.target.scrollTop > allHeight - 190) val.target.scrollTop = 0;
      } catch (error) {}
    },
    getItem() {
      console.log("\n📥 ЗАГРУЗКА НОВОГО РОЗЫГРЫША");
      this.label = "";
      this.participants = [];
      this.additionalItems = [];
      // Сбрасываем список всех победителей при загрузке нового розыгрыша
      this.allWinners = [];
      this.lastSelectedDepartment = null;
      // Сбрасываем счетчики победителей по отделам
      this.winnersByDepartmentCount = {};
      // Сбрасываем предварительный порядок отделов
      this.departmentSelectionOrder = [];
      this.currentDepartmentIndex = 0;
      console.log(
        "✅ Сброшены все победители, история отделов, счетчики и порядок отделов"
      );

      setTimeout(() => {
        this.$loading(true);
        if (this.id) {
          this.$http
            .get(this.cardLink, {
              params: {
                id: this.id,
              },
            })
            .then((response) => {
              this.item = response.data;

              console.log("✅ Данные загружены:");
              console.log(
                `  - Всего участников: ${this.item.participants.length}`
              );
              console.log(
                `  - Победителей за раз: ${this.item.winner_at_once}`
              );

              if (this.item.participants.length > 7) {
                this.additionalItems = this.item.participants;
              }
            })
            .catch(() => {})
            .finally(() => {
              setTimeout(() => {
                this.loading = false;
                this.$loading(false);
              }, 400);
            });
        }
      });
    },

    setWinner() {
      if (this.label && this.label !== "") {
        this.$loading(true);
        this.$http
          .put(this.cardSetLink, {
            id: this.item.id,
            label: this.label,
            participants: this.participants,
          })
          .then((response) => {
            this.$notify({
              title: "Успешно",
              message: "Сохранено",
              icon: "ti-save",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success",
            });
            this.getItem();
          })
          .catch((error) => {
            errorNotify(error, this);
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.$loading(false);
            }, 400);
          });
      } else {
        alert("Введите метку");
      }
    },
  },

  watch: {
    lengthPart(val) {
      this.runAnimate();
    },
    initWinner(val) {
      if (val === true) {
        this.speedAnimation = 0;
      } else if (val === false) {
        this.speedAnimation = 10;
      }
      this.runAnimate();
    },
  },
};
</script>
<style lang="scss">
.video {
  //disable click
  pointer-events: none;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 1;

  background-size: cover;
  transition: 1s opacity;
}

.winner {
  font-family: "Century Gothic", sans-serif !important;
  font-weight: 100 !important;
}
.draw_brands {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 2rem;
  justify-content: center;
  margin: auto;
  display: flex;

  align-items: center;
  & > div {
    margin: 0 50px 0 50px;
    & img {
      height: 45px;
    }
  }
}

.draw_background {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  position: absolute;
  top: -3px;
  left: -3px;
  right: -3px;
  bottom: -3px;
  width: calc(100% + 6px);
  height: calc(100% + 6px);
}

.draw_background_color {
  position: absolute;

  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);
  width: 900px;
  max-width: 900px;
  min-width: 900px;
  height: 600px;
  z-index: 2;

  // background-color: rgba($color: #fff, $alpha: 0.4);

  //box-shadow white
}

.blur {
  // filter: blur(3px);
  //filter for mozilla
  // -moz-filter: blur(3px);
}

.winner-title {
  //font-family: 'Helvetica Neue';
  font-family: 'Helvetica Neue', sans-serif !important;
  font-weight: normal!important;
  font-size: 72px!important;
  text-transform: uppercase !important;
  //color: #681020!important;
}

.button {
  border-radius: 50px;
  box-shadow: none;
  padding: 0 45px !important;
  font-size: 20px !important;
  text-transform: uppercase;
  &-get_winner {
    font-size: 45px !important;
    height: 85px !important;
    margin-top: 25px;

    @media (max-width: 1600px) {
      margin-top: 30px;
      font-size: 40px !important;
      height: 80px !important;
    }
    @media (max-width: 1300px) {
      margin-top: 35px;
      font-size: 30px !important;
      height: 70px !important;
    }
  }
}

.draw_color {
  background: transparent;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}

button {
  font-family: "Century Gothic", sans-serif !important;
  font-weight: 400 !important;
}

.draw_production {
  font-family: "Century Gothic", sans-serif !important;
  position: fixed;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #000;
  z-index: 9;
  background-position: center;
  background-size: cover;

  &.init_winner {
    // -webkit-filter: grayscale(100%);
    // filter: grayscale(100%);
    //add blur
    // filter: blur(1px);
  }

  &-content {
    text-align: center;
    position: relative;
    height: 100vh;
    width: 100%;
    display: block;
    overflow-y: scroll;

    &-shadow {
      &-top {
        z-index: 999;
        height: 1px;
        background: transparent;
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        top: -1px;
      }

      &-bottom {
        z-index: 999;
        height: 1px;
        background: transparent;
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        bottom: -1px;
      }
    }

    &-body {
      // background: rgba($color: #fff, $alpha: 0.9);

      &-participants {
        z-index: -122;
        &::before,
        &::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          height: 50%;

          // background: linear-gradient(
          //   to bottom,
          //   rgba(0, 0, 0, 0.3) 0%,
          //   rgba(0, 0, 0, 0) 100%
          // );
          pointer-events: none;
        }
        // overflow: hidden;
        // margin-top: 40px;
        height: 190px;

        @media (max-width: 1600px) {
          height: 160px;
        }
        @media (max-width: 1300px) {
          height: 140px;
        }
        position: relative;
        overflow-y: scroll;
        margin-top: 72px;
        // overflow-y: visible;
        & ul {
          width: 100%;
          text-align: center;
          padding: 0;
          margin: 0;
          padding-bottom: 50px;
          list-style: none;
          // filter: blur(1px);
          // &.init_winner {
          //   filter: blur(6px);
          // }
          & > li {
            font-size: 29px;
            margin-bottom: 10px;
            // color: #fff;
            height: 44px;
            overflow: hidden;
            text-transform: uppercase;
            line-height: 36px;

            @media (max-width: 1600px) {
              font-size: 24px;
              height: 30px;
            }
            @media (max-width: 1300px) {
              font-size: 20px;
              height: 29px;
            }
          }
        }
      }
      position: absolute;
      left: 50%;
      top: 50%;

      transform: translate(-50%, -50%);

      max-width: 900px;
      min-width: 900px;
      width: 900px;
      // min-height: 400px;
      z-index: 999;

      text-align: center;
      display: block;
      & > h2 {
        //font-family: "FoglihtenNo06" !important;
        font-family: "RF Dewi Extended", sans-serif !important;
        max-width: 900px;
        font-weight: bold !important;
        font-size: 80px;
        line-height: 90px;
        top: 20%;
        margin: 0 auto;
        padding: 0;
        font-weight: 100;
        color: #000;
        margin-bottom: 50px;
      }
      & > button {
        padding-left: 17px;
        padding-right: 17px;
        box-shadow: none;
        border: none;
        font-weight: bold;
        font-size: 24px;
        min-width: 240px;
        width: auto;
        height: 56px;

        &:disabled {
          opacity: 1;
        }
      }
    }
  }

  &-winner {
    margin-top: 3em;
    & > h2 {
      // font-family: "FoglihtenNo06" !important;
      font-family: "RF Dewi Extended", sans-serif !important;
      max-width: 900px;
      font-weight: bold;
      font-size: 80px;
      line-height: 90px;
      top: 20%;
      margin: 0 auto;
      padding: 0;
      color: #000;
      margin-bottom: 50px;
      color: #000;
      font-weight: 100;
      font-size: 80px;
    }
    position: absolute;
    left: 50%;
    top: 50%;

    transform: translate(-50%, -50%);

    width: auto;
    max-width: 900px;
    min-width: 900px;
    max-height: 80vh;
    min-height: 400px;
    z-index: 999;

    text-align: center;
    display: block;
    overflow-y: scroll;
    & textarea {
      width: 100%;
      border-radius: 10px;
      padding: 10px;
      box-shadow: none;
      display: block;
      margin-bottom: 15px;
      border: none;
    }
    & h1 {
      // color: #fff;
      color: #000;
      font-weight: 100;
    }
    & button {
      padding-left: 17px;
      padding-right: 17px;
      box-shadow: none;
      border: none;
      font-weight: bold;
      font-size: 24px;
      min-width: 240px;
      background: #808080;
      color: #fff;
      width: auto;
      height: 56px;
      // border: none;
      // background: #4caf50;
      // color: #fff;
      // font-weight: bold;
      // font-size: 20px;
      // min-width: 240px;
      // width: auto;
      // height: 50px;
      // &:disabled {
      //   opacity: 0.4;
      // }
      // &:last-child {
      //   background: #b71c1c;
      // }
    }
    & ul {
      padding: 0;
      margin: 0 0 23px;
      list-style: none;

      & > li {
        box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
        display: inline-block;
        padding: 8px 38px 11px 38px;
        background: #fff;
        border-radius: 45px;
        color: #000;
        font-weight: bold;
        font-size: 37px;
        line-height: 57px;
        // font-size: 36px;
        // line-height: 42px;
        text-transform: uppercase;
        font-weight: bold !important;
        margin-bottom: 10px;
        min-width: 500px;
      }
    }
  }
}
</style>

